import React, { Component } from 'react'

import classes from './Company.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  getSelectvalue,
  updateObject,
  extractFilterOptions,
  validateForm
} from '../../../../helpers/utils'
import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
// import Button from '../../../../components/UI/Button/Button'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import Collapse from '../../../../components/UI/Collapse/Collapse'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/SetupData/Company/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Checkbox } from '@material-ui/core'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class Company extends Component {
  constructor(props) {
    super(props)

    this.state = {
      modalOpen: false,
      confirmationModalOpen: false,
      filterModalOpen: false,
      action: this.props.translate('add'),
      actionRecordId: null,
      formIsValid: false,
      searchText: '',
      filter: {},
      inputGroups: {
        general: {
          title: this.props.translate('general'),
          open: true,
          form: {
            company_code: {
              label: this.props.translate('companyCode'),
              elementType: 'input',
              elementConfig: {
                type: 'text',
                placeholder: this.props.translate('companyCode')
              },
              value: '',
              validation: {
                required: true
              },
              valid: false,
              touched: false,
              error: null
            },
            company_name: {
              label: this.props.translate('companyName'),
              elementType: 'input',
              elementConfig: {
                type: 'text',
                placeholder: this.props.translate('companyName')
              },
              value: '',
              validation: {
                required: true
              },
              valid: false,
              touched: false,
              error: null
            },
            business_line: {
              label: this.props.translate('lineBusiness'),
              elementType: 'input',
              elementConfig: {
                placeholder: this.props.translate('lineBusiness')
              },
              value: '',
              validation: {
                required: true
              },
              valid: false,
              touched: false,
              error: null
            },
            parent_code: {
              label: this.props.translate('parentCompany'),
              elementType: 'newselect',
              elementConfig: {
                placeholder: this.props.translate('parentCompany'),
                options: [
                  {
                    key: '',
                    value: '',
                    label: this.props.translate('select') + this.props.translate('parentCompany')
                  }
                ],
                selectItemLabel: 'label',
                selectItemValue: 'value',
                dropUp: true
              },
              value: {},
              validation: false,
              valid: true,
              touched: false,
              error: null
            },
            is_active: {
              label: this.props.translate('active'),
              elementType: 'checkbox',
              value: true,
              validation: false,
              valid: true,
              touched: false,
              error: null
            }
          }
        },
        about: {
          title: this.props.translate('about'),
          open: false,
          form: {
            vision: {
              label: this.props.translate('vision'),
              elementType: 'textEditor',
              elementConfig: {},
              value: '',
              validation: false,
              valid: true,
              touched: false,
              error: null
            },
            core_values: {
              label: this.props.translate('value'),
              elementType: 'textEditor',
              elementConfig: {},
              value: '',
              validation: false,
              valid: true,
              touched: false,
              error: null
            },
            mission: {
              label: this.props.translate('mission'),
              elementType: 'textEditor',
              elementConfig: {},
              value: '',
              validation: false,
              valid: true,
              touched: false,
              error: null
            },
            swot: {
              label: this.props.translate('swotAnalysis'),
              elementType: 'textEditor',
              elementConfig: {},
              value: '',
              validation: false,
              valid: true,
              touched: false,
              error: null
            }
          }
        }
        // config: {
        //   title: this.props.translate('config'),
        //   open: false,
        //   form: {
        //     password_policy_id: {
        //       label: this.props.translate('passwordPolicy'),
        //       elementType: 'newselect',
        //       elementConfig: {
        //         placeholder: this.props.translate('passwordPolicy'),
        //         options: [{ key: '', value: '', label: this.props.translate('select') + this.props.translate('passwordPolicy') }]
        //       },
        //       value: {},
        //       validation: {
        //         required: true
        //       },
        //       valid: false,
        //       touched: false,
        //       error: null
        //     },
        //     ldap_server_id: {
        //       label: this.props.translate('ldap'),
        //       elementType: 'newselect',
        //       elementConfig: {
        //         placeholder: this.props.translate('ldap'),
        //         options: [{ key: '', value: '', label: this.props.translate('select') + this.props.translate('ldap') }]
        //       },
        //       value: {},
        //       validation: false,
        //       valid: true,
        //       touched: false,
        //       error: null
        //     },
        //     email_server_id: {
        //       label: this.props.translate('eMailServer'),
        //       elementType: 'newselect',
        //       elementConfig: {
        //         placeholder: this.props.translate('eMailServer'),
        //         options: [{ key: '', value: '', label: this.props.translate('select') + this.props.translate('eMailServer') }],
        //         dropUp: true
        //       },
        //       value: {},
        //       validation: {
        //         required: true
        //       },
        //       valid: false,
        //       touched: false,
        //       error: null
        //     }
        //   }
        // }
      },
      filterControls: {
        company_id: {
          label: this.props.translate('companyName'),
          value: {},
          configs: { placeholder: this.props.translate('companyName'), options: [] }
        }
      },
      selectedRecord: null,
      filterOptions: {
        parentCompanyOptions: null
      },
      addAno: false
    }

    this.rowActions = [
      {
        icon: () => <Add />,
        tooltip: this.props.translate('add') + this.props.translate('company'),
        onClick: () => this.openModalHandler('add'),
        isFreeAction: true,
        disabled: !props.pagePermission.is_add
      },
      {
        icon: () => <Edit fontSize={'small'} />,
        tooltip: this.props.translate('edit') + this.props.translate('company'),
        onClick: (event, rowData) => this.openModalHandler('edit', rowData.company_id),
        disabled: !props.pagePermission.is_edit
      },
      {
        icon: () => <Delete fontSize={'small'} />,
        tooltip: this.props.translate('delete') + this.props.translate('company'),
        onClick: (event, rowData) => this.openModalHandler('delete', rowData.company_id),
        disabled: !props.pagePermission.is_delete
      }
    ]
  }

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'company_code', title: this.props.translate('companyCode'), type: 'string' },
    { field: 'company_name', title: this.props.translate('companyName'), type: 'string' },
    { field: 'business_line', title: this.props.translate('lineBusiness'), type: 'string' },
    {
      field: 'is_active',
      title: this.props.translate('active'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_active} disabled />
      },
      width: 100
    }
  ]

  componentDidMount() {
    this.props.fetchCompanies()
    this.clearModal()
    this.props.fetchOptions()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
    // if (this.props.passwordPolicyOptions !== prevProps.passwordPolicyOptions) {
    //   let inputGroups = this.state.inputGroups
    //   let targetGroup = inputGroups.config
    //   let targetForm = targetGroup.form
    //   let targetFormItem = targetForm.password_policy_id
    //   let updatedFormItem = updateFormOptions(
    //     this.props.passwordPolicyOptions,
    //     targetFormItem,
    //     'password_policy_id',
    //     'password_policy_id',
    //     'password_policy_name',
    //     'Select Password Policy'
    //   )

    //   this.setState({
    //     inputGroups: {
    //       ...inputGroups,
    //       config: {
    //         ...targetGroup,
    //         form: {
    //           ...targetForm,
    //           password_policy_id: updatedFormItem
    //         }
    //       }
    //     }
    //   })
    // }
    // if (this.props.ldapServerOptions !== prevProps.ldapServerOptions) {
    //   let inputGroups = this.state.inputGroups
    //   let targetGroup = inputGroups.config
    //   let targetForm = targetGroup.form
    //   let targetFormItem = targetForm.ldap_server_id
    //   let updatedFormItem = updateFormOptions(
    //     this.props.ldapServerOptions,
    //     targetFormItem,
    //     'ldap_server_id',
    //     'ldap_server_id',
    //     'ldap_server_name',
    //     'Select LDAP Server'
    //   )

    //   this.setState({
    //     inputGroups: {
    //       ...inputGroups,
    //       config: {
    //         ...targetGroup,
    //         form: {
    //           ...targetForm,
    //           ldap_server_id: updatedFormItem
    //         }
    //       }
    //     }
    //   })
    // }
    // if (this.props.emailServerOptions !== prevProps.emailServerOptions) {
    //   let inputGroups = this.state.inputGroups
    //   let targetGroup = inputGroups.config
    //   let targetForm = targetGroup.form
    //   let targetFormItem = targetForm.email_server_id
    //   let updatedFormItem = updateFormOptions(
    //     this.props.emailServerOptions,
    //     targetFormItem,
    //     'email_server_id',
    //     'email_server_id',
    //     'email_server_name',
    //     'Select Email Server'
    //   )

    //   this.setState({
    //     inputGroups: {
    //       ...inputGroups,
    //       config: {
    //         ...targetGroup,
    //         form: {
    //           ...targetForm,
    //           email_server_id: updatedFormItem
    //         }
    //       }
    //     }
    //   })
    // }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.parentCompanyOptions !== state.filterOptions.parentCompanyOptions) {
      let inputGroups = state.inputGroups
      let targetGroup = inputGroups.general
      let targetForm = targetGroup.form
      let targetFormItem = targetForm.parent_code
      let updatedFormItem = updateFormOptions(
        props.parentCompanyOptions,
        targetFormItem,
        'company_id',
        'company_code',
        { code: 'company_code', name: 'company_name' },
        'Select Parent Company'
      )
      let targetFilterItem = state.filterControls.company_id
      let updatedFilter = updateFilterOptions(
        props.parentCompanyOptions,
        targetFilterItem,
        'company_id',
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      )

      return {
        inputGroups: updateObject(inputGroups, {
          general: updateObject(targetGroup, {
            form: updateObject(targetForm, { parent_code: updatedFormItem })
          })
        }),
        filterControls: {
          company_id: updatedFilter
        },
        filterOptions: {
          parentCompanyOptions: props.parentCompanyOptions
        }
      }
    }
    if (
      props.selectedRecord !== state.selectedRecord &&
      state.filterOptions.parentCompanyOptions !== null
    ) {
      let formValid = true
      let newInputGroupState = Object.entries(state.inputGroups).reduce((inputGroups, group) => {
        let [groupKey, groupAttrs] = group

        const newFormData = Object.entries(groupAttrs.form).reduce((formGroups, form) => {
          let [formKey, formAttrs] = form

          let value = ''
          let valid = !formAttrs.validation
          let touched = false
          let errorMessage = null
          if (formAttrs.elementType === 'checkbox') {
            value = false
          }
          if (props.selectedRecord && props.selectedRecord[formKey]) {
            value = props.selectedRecord[formKey] || null

            if (formAttrs.elementType === 'newselect') {
              value = getSelectvalue(
                value,
                state.inputGroups[groupKey].form[formKey].elementConfig.options
              )
            } else if (formAttrs.elementType === 'checkbox') {
              value = !!props.selectedRecord[formKey]
            }

            let { isValid, error } = checkValidity(value, formAttrs.validation, formAttrs.label)

            valid = isValid
            errorMessage = error
          }

          formValid = formValid && valid

          const newFormAttrs = {
            ...formAttrs,
            value: value,
            valid: valid,
            error: errorMessage,
            touched: touched
          }

          return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
        }, {})

        const newGroupAttrs = updateObject(groupAttrs, { form: newFormData })
        return updateObject(inputGroups, { [groupKey]: { ...newGroupAttrs } })
      }, {})

      return {
        inputGroups: newInputGroupState,
        formIsValid: formValid,
        selectedRecord: props.selectedRecord
      }
    }
    return null
  }

  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchCompanies(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchCompanies(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }

  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchCompanyById(recordId)
    }

    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }

  openModal = () => {
    this.setState({
      modalOpen: true
    })
  }

  // closeModal = () => {
  //   this.clearModal()
  //   this.setState({
  //     modalOpen: false
  //   })
  // }
  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false
      })
    }
  }

  clearModal = () => {
    this.props.clearSelectedRecord()

    const formData = Object.entries(this.state.inputGroups).reduce((formData, formEntry) => {
      let [formKey, formAttrs] = formEntry
      formAttrs = { ...formAttrs, open: false }
      if (formKey === 'general') {
        formAttrs = { ...formAttrs, open: true }
      }
      formAttrs.form = Object.entries(formAttrs.form).reduce((acc, cur) => {
        let [inputKey, inputAttrs] = cur
        inputAttrs = { ...inputAttrs, value: '' }
        if (inputAttrs.elementType === 'checkbox') {
          inputAttrs = { ...inputAttrs, value: false }
        }

        if (inputKey === 'is_active') {
          inputAttrs = { ...inputAttrs, value: true }
        }
        return updateObject(acc, { [inputKey]: inputAttrs })
      }, {})
      return updateObject(formData, { [formKey]: formAttrs })
    }, {})
    if (this.state.addAno) {
      this.setState({
        inputGroups: formData,
        actionRecordId: null,
        addAno: false
      })
    } else {
      this.setState({
        inputGroups: formData,
        actionRecordId: null,
        modalOpen: false
      })
    }
  }

  formSubmitHandler = type => {
    const groupData = Object.entries(this.state.inputGroups).reduce((groupData, groupEntry) => {
      let [, groupAttrs] = groupEntry
      return updateObject(groupData, { ...groupAttrs.form })
    }, {})

    const formData = Object.entries(groupData).reduce((formData, formEntry) => {
      let [formKey, formAttrs] = formEntry
      let value = formAttrs.value
      if (formAttrs.elementType === 'newselect' && value) {
        value = formAttrs.value?.value
      }
      return updateObject(formData, { [formKey]: value })
    }, {})

    if (this.state.action === 'add') {
      this.props.createCompany({ ...formData }, getPageStatus(this.props.pagination, false))
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updateCompany(
        this.state.actionRecordId,
        { ...formData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  toggleCollapse = groupKey => {
    this.setState(prevState => {
      let collapseItem = { ...prevState.inputGroups[groupKey] }
      return {
        inputGroups: updateObject(prevState.inputGroups, {
          [groupKey]: { ...collapseItem, open: !collapseItem.open }
        })
      }
    })
  }

  deleteRecord = () => {
    const recordId = this.state.actionRecordId

    this.props.deleteCompany(recordId, getPageStatus(this.props.pagination, true))

    this.closeConfirmationModal()
  }

  inputChangeHandler = (groupKey, formKey, event) => {
    const inputGroup = this.state.inputGroups[groupKey]
    const formItem = inputGroup.form[formKey]

    let inputValue = ''

    if (formItem.elementType === 'textEditor') {
      inputValue = event
    } else if (formItem.elementType === 'newselect') {
      inputValue = event
    } else if (formItem.elementType === 'checkbox') {
      inputValue = event.target.checked
    } else {
      inputValue = event.target.value
    }

    const { isValid, error } = checkValidity(inputValue, formItem.validation, formItem.label)

    const updatedFormItem = {
      ...formItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }

    const updatedForm = updateObject(inputGroup.form, { [formKey]: updatedFormItem })

    const updatedGroup = updateObject(inputGroup, { form: updatedForm })

    const updatedInputGroups = updateObject(this.state.inputGroups, { [groupKey]: updatedGroup })

    let formIsValid = true

    Object.values(updatedInputGroups).map(group => {
      Object.entries(group.form).map(form => {
        let [, formAttrs] = form
        return (formIsValid = formIsValid && formAttrs.valid)
      })
      return group
    })

    this.setState({
      inputGroups: updateObject(this.state.inputGroups, { [groupKey]: updatedGroup }),
      formIsValid: formIsValid
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false,
      actionRecordId: null
    })
  }

  openConfirmationModal = recordId => {
    if (recordId) {
      this.setState({
        confirmationModalOpen: true
      })
    }
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    this.props.fetchOptions()
    this.setState({
      filterModalOpen: true
    })
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    this.setState({
      filterControls: updateObject(this.state.filterControls, {
        [itemKey]: updateObject(filterItem, { value: filterValue })
      }),
      filter: { ...this.state.filter, [itemKey]: filterValue?.value }
    })
  }

  filterRecords = () => {
    let param = { ...this.state.filter, page: 1, perPage: this.props.pagination.perPage }
    this.props.fetchCompanies(param)

    this.setState({
      filterModalOpen: false
    })
  }

  render() {
    let collapseGroup = <Spinner />
    if (!this.props.loadingStates.includes('saveCompany')) {
      collapseGroup = Object.entries(this.state.inputGroups).map(item => {
        let [groupKey, groupAttrs] = item

        return (
          <Collapse
            key={groupKey}
            title={groupAttrs.title}
            show={groupAttrs.open}
            toggleBarClicked={() => this.toggleCollapse(groupKey)}>
            <Form
              saved={(formData, event) => this.formSubmitHandler(formData, event)}
              cancelled={this.closeModal}
              form={groupAttrs.form}
              inputChanged={(formKey, e) => this.inputChangeHandler(groupKey, formKey, e)}
              formValid={this.state.formIsValid}
              selectedRecord={this.props.selectedRecord}
            />
          </Collapse>
        )
      })
    }
    const footer = (
      <Footer
        save={() => this.formSubmitHandler('save')}
        another={() => this.formSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!validateForm(this.state.inputGroups.general.form)}
      />
    )

    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
          loadingQueue={this.props.loadingStates}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('company')}
          backdropClicked={this.closeModal}
          footer={footer}>
          {collapseGroup}
        </Modal>
        <Card>
          <CardHeader>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('company')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingStates.includes('companyRecords')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.companies.pagination,
    data: state.companies.records,
    loadingStates: state.companies.loadingStates,
    success: state.companies.success,
    selectedRecord: state.companies.selectedRecord,
    parentCompanyOptions: state.companies.parentCompanies,
    passwordPolicyOptions: state.companies.passwordPolicies,
    ldapServerOptions: state.companies.ldapServers,
    emailServerOptions: state.companies.emailServers
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchCompanies: filterOptions => dispatch(actions.fetchCompanies(filterOptions)),
    fetchCompanyById: recordId => dispatch(actions.fetchCompanyById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedCompanyRecord()),
    createCompany: (recordData, page) => dispatch(actions.createCompany(recordData, page)),
    updateCompany: (recordId, recordData, page) =>
      dispatch(actions.updateCompany(recordId, recordData, page)),
    deleteCompany: (recordId, page) => dispatch(actions.deleteCompany(recordId, page)),
    fetchOptions: () => {
      dispatch(actions.fetchParentCompanyOptions())
      dispatch(actions.fetchPasswordPolicyOptions())
      dispatch(actions.fetchLdapServerOptions())
      dispatch(actions.fetchEmailServerOptions())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(Company))
